export default __webpack_public_path__ + "static/media/TataSteel.36ca1fe7.webp";